
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../services/authContext';
import { getUserPreferences, updateUserPreferences, deleteUserAccount } from '../../services/preferencesService';
import CheckboxList from './CheckboxList';
import { useFilterOptions } from '../../services/filtersContext';
import './Profile.css';

export default function Profile() {
  const { user, token, logout } = useAuth();
  const { brands: BRANDS, sizes: SIZES, genders: GENDERS, colors: COLORS, categories: CATEGORIES } = useFilterOptions();
  const [prefs, setPrefs] = useState({ brands: [], genders: [], sizes: [], colors: [], categories: [], optedInEmail: false });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    getUserPreferences(token)
      .then(data => {
        setPrefs({
          brands: data?.brands || [],
          genders: data?.genders || [],
          sizes: data?.sizes || [],
          colors: data?.colors || [],
          categories: data?.categories || [],
          optedInEmail: !!data?.optedInEmail,
        });
      })
      .catch(() => setPrefs({ brands: [], genders: [], sizes: [], colors: [], categories: [], optedInEmail: false }))
      .finally(() => setLoading(false));
  }, [token]);


  // Extracted logic for updating array fields
  function handleArrayChange(field, values) {
    console.log('Local state update only:', field, values);
    setPrefs(p => ({ ...p, [field]: values }));
  }

  function handleCheckbox(e) {
    const { name, checked } = e.target;
    setPrefs(p => ({ ...p, [name]: checked }));
  }

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      console.log('Saving preferences to backend:', prefs);
      await updateUserPreferences(token, prefs);
      setMessage('Preferences saved!');
    } catch {
      setMessage('Failed to save preferences.');
    }
    setSaving(false);
  }

  if (!user) return <div className="profile-container">Please log in to view your profile.</div>;

  return (
    <div className="profile-container">
      <h2>Your Profile</h2>
      <div className="profile-info">
        <div><strong>First Name:</strong> {user.firstName}</div>
        <div><strong>Last Name:</strong> {user.lastName}</div>
        <div><strong>Email:</strong> {user.email}</div>
      </div>
      <hr style={{ margin: '32px 0 24px 0', border: 0, borderTop: '1px solid #eee' }} />
      <form className="prefs-form" onSubmit={handleSave}>
        <h3>Filter Preferences</h3>
        <CheckboxList
          title="Brands"
          values={BRANDS}
          checkedValues={prefs.brands}
          onChange={vals => handleArrayChange('brands', vals)}
        />
        <CheckboxList
          title="Genders"
          values={GENDERS}
          checkedValues={prefs.genders}
          onChange={vals => handleArrayChange('genders', vals)}
        />
        <CheckboxList
          title="Sizes"
          values={SIZES}
          checkedValues={prefs.sizes}
          onChange={vals => handleArrayChange('sizes', vals)}
        />
        <CheckboxList
          title="Colors"
          values={COLORS}
          checkedValues={prefs.colors}
          onChange={vals => handleArrayChange('colors', vals)}
        />
        <CheckboxList
          title="Categories"
          values={CATEGORIES}
          checkedValues={prefs.categories}
          onChange={vals => handleArrayChange('categories', vals)}
        />
        <div className="prefs-field">
          <label>
            <input type="checkbox" name="optedInEmail" checked={prefs.optedInEmail} onChange={handleCheckbox} disabled />
            &nbsp;Opt in for email alerts (coming soon)
          </label>
        </div>
        <button type="submit" className="save-prefs-btn" disabled={loading || saving}>{saving ? 'Saving...' : 'Save Preferences'}</button>
        {message && <div className="prefs-message">{message}</div>}
      </form>
      <hr style={{ margin: '32px 0 24px 0', border: 0, borderTop: '1px solid #eee' }} />
      <button
        className="delete-account-btn"
        onClick={async () => {
          if (window.confirm('Are you sure you want to delete your account? This cannot be undone.')) {
            try {
              await deleteUserAccount(token);
              logout();
            } catch {
              alert('Failed to delete account.');
            }
          }
        }}
      >
        Delete Account
      </button>
    </div>
  );
}
